export const countries = [
  {
    "name": "United States of America",
    "phoneCode": "+1",
    "alpha2code": "US",
    "code": "USA",
  },
  {
    "name": "Canada",
    "phoneCode": "+1",
    "alpha2code": "CA",
    "code": "CAN",
  },
  {
    "name": "Afghanistan",
    "phoneCode": "+93",
    "alpha2code": "AF",
    "code": "AFG",
  },
  {
    "name": "Albania",
    "phoneCode": "+355",
    "alpha2code": "AL",
    "code": "ALB",
  },
  {
    "name": "Algeria",
    "phoneCode": "+213",
    "alpha2code": "DZ",
    "code": "DZA",
  },
  {
    "name": "Andorra",
    "phoneCode": "+376",
    "alpha2code": "AD",
    "code": "AND",
  },
  {
    "name": "Angola",
    "phoneCode": "+244",
    "alpha2code": "AO",
    "code": "AGO",
  },
  {
    "name": "Anguilla",
    "phoneCode": "+1",
    "alpha2code": "AI",
    "code": "AIA",
  },
  {
    "name": "Antigua and Barbuda",
    "phoneCode": "+1",
    "alpha2code": "AG",
    "code": "ATG",
  },
  {
    "name": "Argentina",
    "phoneCode": "+54",
    "alpha2code": "AR",
    "code": "ARG",
  },
  {
    "name": "Armenia",
    "phoneCode": "+374",
    "alpha2code": "AM",
    "code": "ARM",
  },
  {
    "name": "Aruba",
    "phoneCode": "+297",
    "alpha2code": "AW",
    "code": "ABW",
  },
  {
    "name": "Australia",
    "phoneCode": "+61",
    "alpha2code": "AU",
    "code": "AUS",
  },
  {
    "name": "Austria",
    "phoneCode": "+43",
    "alpha2code": "AT",
    "code": "AUT",
  },
  {
    "name": "Azerbaijan",
    "phoneCode": "+994",
    "alpha2code": "AZ",
    "code": "AZE",
  },
  {
    "name": "Bahrain",
    "phoneCode": "+973",
    "alpha2code": "BH",
    "code": "BHR",
  },
  {
    "name": "Bangladesh",
    "phoneCode": "+880",
    "alpha2code": "BD",
    "code": "BGD",
  },
  {
    "name": "Barbados",
    "phoneCode": "+1",
    "alpha2code": "BB",
    "code": "BRB",
  },
  {
    "name": "Belarus",
    "phoneCode": "+375",
    "alpha2code": "BY",
    "code": "BLR",
  },
  {
    "name": "Belgium",
    "phoneCode": "+32",
    "alpha2code": "BE",
    "code": "BEL",
  },
  {
    "name": "Belize",
    "phoneCode": "+501",
    "alpha2code": "BZ",
    "code": "BLZ",
  },
  {
    "name": "Benin",
    "phoneCode": "+229",
    "alpha2code": "BJ",
    "code": "BEN",
  },
  {
    "name": "Bermuda",
    "phoneCode": "+1",
    "alpha2code": "BM",
    "code": "BMU",
  },
  {
    "name": "Bhutan",
    "phoneCode": "+975",
    "alpha2code": "BT",
    "code": "BTN",
  },
  {
    "name": "Bolivia",
    "phoneCode": "+591",
    "alpha2code": "BO",
    "code": "BOL",
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "phoneCode": "+599",
    "alpha2code": "BQ",
    "code": "BES",
  },
  {
    "name": "Bosnia and Herzegovina",
    "phoneCode": "+387",
    "alpha2code": "BA",
    "code": "BIH",
  },
  {
    "name": "Botswana",
    "phoneCode": "+267",
    "alpha2code": "BW",
    "code": "BWA",
  },
  {
    "name": "Brazil",
    "phoneCode": "+55",
    "alpha2code": "BR",
    "code": "BRA",
  },
  {
    "name": "British Indian Ocean Territory",
    "phoneCode": "+246",
    "alpha2code": "IO",
    "code": "IOT",
  },
  {
    "name": "British Virgin Islands",
    "phoneCode": "+1",
    "alpha2code": "VG",
    "code": "VGB",
  },
  {
    "name": "Brunei Darussalam",
    "phoneCode": "+673",
    "alpha2code": "BN",
    "code": "BRN",
  },
  {
    "name": "Bulgaria",
    "phoneCode": "+359",
    "alpha2code": "BG",
    "code": "BGR",
  },
  {
    "name": "Burkina Faso",
    "phoneCode": "+226",
    "alpha2code": "BF",
    "code": "BFA",
  },
  {
    "name": "Myanmar",
    "phoneCode": "+95",
    "alpha2code": "MM",
    "code": "MMR",
  },
  {
    "name": "Burundi",
    "phoneCode": "+257",
    "alpha2code": "BI",
    "code": "BDI",
  },
  {
    "name": "Cambodia",
    "phoneCode": "+855",
    "alpha2code": "KH",
    "code": "KHM",
  },
  {
    "name": "Cameroon",
    "phoneCode": "+237",
    "alpha2code": "CM",
    "code": "CMR",
  },
  {
    "name": "Cabo Verde",
    "phoneCode": "+238",
    "alpha2code": "CV",
    "code": "CPV",
  },
  {
    "name": "Cayman Islands",
    "phoneCode": "+1",
    "alpha2code": "KY",
    "code": "CYM",
  },
  {
    "name": "Central African Republic",
    "phoneCode": "+236",
    "alpha2code": "CF",
    "code": "CAF",
  },
  {
    "name": "Chad",
    "phoneCode": "+235",
    "alpha2code": "ID",
    "code": "TCD",
  },
  {
    "name": "Chile",
    "phoneCode": "+56",
    "alpha2code": "CL",
    "code": "CHL",
  },
  {
    "name": "China",
    "phoneCode": "+86",
    "alpha2code": "CN",
    "code": "CHN",
  },
  {
    "name": "Colombia",
    "phoneCode": "+57",
    "alpha2code": "CO",
    "code": "COL",
  },
  {
    "name": "Comoros",
    "phoneCode": "+269",
    "alpha2code": "KM",
    "code": "COM",
  },
  {
    "name": "Cook Islands",
    "phoneCode": "+682",
    "alpha2code": "CK",
    "code": "COK",
  },
  {
    "name": "Costa Rica",
    "phoneCode": "+506",
    "alpha2code": "CR",
    "code": "CRI",
  },
  {
    "name": "Côte dIvoire",
    "phoneCode": "+225",
    "alpha2code": "CI",
    "code": "CIV",
  },
  {
    "name": "Croatia",
    "phoneCode": "+385",
    "alpha2code": "HR",
    "code": "HRV",
  },
  {
    "name": "Cuba",
    "phoneCode": "+53",
    "alpha2code": "CU",
    "code": "CUB",
  },
  {
    "name": "Curaçao",
    "phoneCode": "+599",
    "alpha2code": "CW",
    "code": "CUW",
  },
  {
    "name": "Cyprus",
    "phoneCode": "+357",
    "alpha2code": "CY",
    "code": "CYP",
  },
  {
    "name": "Czechia",
    "phoneCode": "+420",
    "alpha2code": "CZ",
    "code": "CZE",
  },
  {
    "name": "Denmark",
    "phoneCode": "+45",
    "alpha2code": "DK",
    "code": "DNK",
  },
  {
    "name": "Djibouti",
    "phoneCode": "+253",
    "alpha2code": "DJ",
    "code": "DJI",
  },
  {
    "name": "Dominica",
    "phoneCode": "+1",
    "alpha2code": "DM",
    "code": "DMA",
  },
  {
    "name": "Dominican Republic",
    "phoneCode": "+1",
    "alpha2code": "DO",
    "code": "DOM",
  },
  {
    "name": "Ecuador",
    "phoneCode": "+593",
    "alpha2code": "EC",
    "code": "ECU",
  },
  {
    "name": "Egypt",
    "phoneCode": "+20",
    "alpha2code": "EG",
    "code": "EGY",
  },
  {
    "name": "El Salvador",
    "phoneCode": "+503",
    "alpha2code": "SV",
    "code": "SLV",
  },
  {
    "name": "Equatorial Guinea",
    "phoneCode": "+240",
    "alpha2code": "GQ",
    "code": "GNQ",
  },
  {
    "name": "Eritrea",
    "phoneCode": "+291",
    "alpha2code": "ER",
    "code": "ERI",
  },
  {
    "name": "Estonia",
    "phoneCode": "+372",
    "alpha2code": "EE",
    "code": "EST",
  },
  {
    "name": "Ethiopia",
    "phoneCode": "+251",
    "alpha2code": "ET",
    "code": "ETH",
  },
  {
    "name": "Falkland Islands",
    "phoneCode": "+500",
    "alpha2code": "FK",
    "code": "FLK",
  },
  {
    "name": "Faroe Islands",
    "phoneCode": "+298",
    "alpha2code": "FO",
    "code": "FRO",
  },
  {
    "name": "Federated States of Micronesia",
    "phoneCode": "+691",
    "alpha2code": "FM",
    "code": "FSM",
  },
  {
    "name": "Fiji",
    "phoneCode": "+679",
    "alpha2code": "FJ",
    "code": "FJI",
  },
  {
    "name": "Finland",
    "phoneCode": "+358",
    "alpha2code": "FI",
    "code": "FIN",
  },
  {
    "name": "France",
    "phoneCode": "+33",
    "alpha2code": "FR",
    "code": "FRA",
  },
  {
    "name": "French Guiana",
    "phoneCode": "+594",
    "alpha2code": "GF",
    "code": "GUF",
  },
  {
    "name": "French Polynesia",
    "phoneCode": "+689",
    "alpha2code": "PF",
    "code": "PYF",
  },
  {
    "name": "Gabon",
    "phoneCode": "+241",
    "alpha2code": "GA",
    "code": "GAB",
  },
  {
    "name": "Georgia",
    "phoneCode": "+995",
    "alpha2code": "GE",
    "code": "GEO",
  },
  {
    "name": "Germany",
    "phoneCode": "+49",
    "alpha2code": "DE",
    "code": "DEU",
  },
  {
    "name": "Ghana",
    "phoneCode": "+233",
    "alpha2code": "GH",
    "code": "GHA",
  },
  {
    "name": "Gibraltar",
    "phoneCode": "+350",
    "alpha2code": "GI",
    "code": "GIB",
  },
  {
    "name": "Greece",
    "phoneCode": "+30",
    "alpha2code": "GR",
    "code": "GRC",
  },
  {
    "name": "Greenland",
    "phoneCode": "+299",
    "alpha2code": "GL",
    "code": "GRL",
  },
  {
    "name": "Grenada",
    "phoneCode": "+1",
    "alpha2code": "GD",
    "code": "GRD",
  },
  {
    "name": "Guadeloupe",
    "phoneCode": "+590",
    "alpha2code": "GP",
    "code": "GLP",
  },
  {
    "name": "Guatemala",
    "phoneCode": "+502",
    "alpha2code": "GT",
    "code": "GTM",
  },
  {
    "name": "Guinea",
    "phoneCode": "+224",
    "alpha2code": "GN",
    "code": "GIN",
  },
  {
    "name": "Guinea-Bissau",
    "phoneCode": "+245",
    "alpha2code": "GW",
    "code": "GNB",
  },
  {
    "name": "Guyana",
    "phoneCode": "+592",
    "alpha2code": "GY",
    "code": "GUY",
  },
  {
    "name": "Haiti",
    "phoneCode": "+509",
    "alpha2code": "HT",
    "code": "HTI",
  },
  {
    "name": "Honduras",
    "phoneCode": "+504",
    "alpha2code": "HN",
    "code": "HND",
  },
  {
    "name": "Hong Kong",
    "phoneCode": "+852",
    "alpha2code": "HK",
    "code": "HKG",
  },
  {
    "name": "Hungary",
    "phoneCode": "+36",
    "alpha2code": "HU",
    "code": "HUN",
  },
  {
    "name": "Iceland",
    "phoneCode": "+354",
    "alpha2code": "IS",
    "code": "ISL",
  },
  {
    "name": "India",
    "phoneCode": "+91",
    "alpha2code": "IN",
    "code": "IND",
  },
  {
    "name": "Indonesia",
    "phoneCode": "+62",
    "alpha2code": "ID",
    "code": "IDN",
  },
  {
    "name": "Iran",
    "phoneCode": "+98",
    "alpha2code": "IR",
    "code": "IRN",
  },
  {
    "name": "Iraq",
    "phoneCode": "+964",
    "alpha2code": "IQ",
    "code": "IRQ",
  },
  {
    "name": "Ireland",
    "phoneCode": "+353",
    "alpha2code": "IE",
    "code": "IRL",
  },
  {
    "name": "Israel",
    "phoneCode": "+972",
    "alpha2code": "IL",
    "code": "ISR",
  },
  {
    "name": "Italy",
    "phoneCode": "+39",
    "alpha2code": "IT",
    "code": "ITA",
  },
  {
    "name": "Jamaica",
    "phoneCode": "+1",
    "alpha2code": "JM",
    "code": "JAM",
  },
  {
    "name": "Japan",
    "phoneCode": "+81",
    "alpha2code": "JP",
    "code": "JPN",
  },
  {
    "name": "Jordan",
    "phoneCode": "+962",
    "alpha2code": "JO",
    "code": "JOR",
  },
  {
    "name": "Kazakhstan",
    "phoneCode": "+7",
    "alpha2code": "KZ",
    "code": "KAZ",
  },
  {
    "name": "Kenya",
    "phoneCode": "+254",
    "alpha2code": "KE",
    "code": "KEN",
  },
  {
    "name": "Kiribati",
    "phoneCode": "+686",
    "alpha2code": "KI",
    "code": "KIR",
  },
  {
    "name": "Kuwait",
    "phoneCode": "+965",
    "alpha2code": "KW",
    "code": "KWT",
  },
  {
    "name": "Kyrgyzstan",
    "phoneCode": "+996",
    "alpha2code": "KG",
    "code": "KGZ",
  },
  {
    "name": "Lao People's Democratic Republic",
    "phoneCode": "+856",
    "alpha2code": "LA",
    "code": "LAO",
  },
  {
    "name": "Latvia",
    "phoneCode": "+371",
    "alpha2code": "LV",
    "code": "LVA",
  },
  {
    "name": "Lebanon",
    "phoneCode": "+961",
    "alpha2code": "LB",
    "code": "LBN",
  },
  {
    "name": "Lesotho",
    "phoneCode": "+266",
    "alpha2code": "LS",
    "code": "LSO",
  },
  {
    "name": "Liberia",
    "phoneCode": "+231",
    "alpha2code": "LR",
    "code": "LBR",
  },
  {
    "name": "Libya",
    "phoneCode": "+218",
    "alpha2code": "LY",
    "code": "LBY",
  },
  {
    "name": "Liechtenstein",
    "phoneCode": "+423",
    "alpha2code": "LI",
    "code": "LIE",
  },
  {
    "name": "Lithuania",
    "phoneCode": "+370",
    "alpha2code": "LT",
    "code": "LTU",
  },
  {
    "name": "Luxembourg",
    "phoneCode": "+352",
    "alpha2code": "LU",
    "code": "LUX",
  },
  {
    "name": "Macao",
    "phoneCode": "+853",
    "alpha2code": "MO",
    "code": "MAC",
  },
  {
    "name": "Macedonia",
    "phoneCode": "+389",
    "alpha2code": "MK",
    "code": "MKD",
  },
  {
    "name": "Madagascar",
    "phoneCode": "+261",
    "alpha2code": "MG",
    "code": "MDG",
  },
  {
    "name": "Malawi",
    "phoneCode": "+265",
    "alpha2code": "MW",
    "code": "MWI",
  },
  {
    "name": "Malaysia",
    "phoneCode": "+60",
    "alpha2code": "MY",
    "code": "MYS",
  },
  {
    "name": "Maldives",
    "phoneCode": "+960",
    "alpha2code": "MV",
    "code": "MDV",
  },
  {
    "name": "Mali",
    "phoneCode": "+223",
    "alpha2code": "ML",
    "code": "MLI",
  },
  {
    "name": "Malta",
    "phoneCode": "+356",
    "alpha2code": "MT",
    "code": "MLT",
  },
  {
    "name": "Marshall Islands",
    "phoneCode": "+692",
    "alpha2code": "MH",
    "code": "MHL",
  },
  {
    "name": "Martinique",
    "phoneCode": "+596",
    "alpha2code": "MQ",
    "code": "MTQ",
  },
  {
    "name": "Mauritania",
    "phoneCode": "+222",
    "alpha2code": "MR",
    "code": "MRT",
  },
  {
    "name": "Mauritius",
    "phoneCode": "+230",
    "alpha2code": "MU",
    "code": "MUS",
  },
  {
    "name": "Mayotte",
    "phoneCode": "+262",
    "alpha2code": "YT",
    "code": "MYT",
  },
  {
    "name": "Mexico",
    "phoneCode": "+52",
    "alpha2code": "MX",
    "code": "MEX",
  },
  {
    "name": "Moldova",
    "phoneCode": "+373",
    "alpha2code": "MD",
    "code": "MDA",
  },
  {
    "name": "Monaco",
    "phoneCode": "+377",
    "alpha2code": "MC",
    "code": "MCO",
  },
  {
    "name": "Mongolia",
    "phoneCode": "+976",
    "alpha2code": "MN",
    "code": "MNG",
  },
  {
    "name": "Montenegro",
    "phoneCode": "+382",
    "alpha2code": "ME",
    "code": "MNE",
  },
  {
    "name": "Montserrat",
    "phoneCode": "+1",
    "alpha2code": "MS",
    "code": "MSR",
  },
  {
    "name": "Morocco",
    "phoneCode": "+212",
    "alpha2code": "MA",
    "code": "MAR",
  },
  {
    "name": "Mozambique",
    "phoneCode": "+258",
    "alpha2code": "MZ",
    "code": "MOZ",
  },
  {
    "name": "Namibia",
    "phoneCode": "+264",
    "alpha2code": "NA",
    "code": "NAM",
  },
  {
    "name": "Nauru",
    "phoneCode": "+674",
    "alpha2code": "NR",
    "code": "NRU",
  },
  {
    "name": "Nepal",
    "phoneCode": "+977",
    "alpha2code": "NP",
    "code": "NPL",
  },
  {
    "name": "Netherlands",
    "phoneCode": "+31",
    "alpha2code": "NL",
    "code": "NLD",
  },
  {
    "name": "Netherlands Antilles",
    "phoneCode": "+599",
    "alpha2code": "AN",
    "code": "ANT",
  },
  {
    "name": "New Caledonia",
    "phoneCode": "+687",
    "alpha2code": "NC",
    "code": "NCL",
  },
  {
    "name": "New Zealand",
    "phoneCode": "+64",
    "alpha2code": "NZ",
    "code": "NZL",
  },
  {
    "name": "Nicaragua",
    "phoneCode": "+505",
    "alpha2code": "NI",
    "code": "NIC",
  },
  {
    "name": "Niger",
    "phoneCode": "+227",
    "alpha2code": "NE",
    "code": "NER",
  },
  {
    "name": "Nigeria",
    "phoneCode": "+234",
    "alpha2code": "NG",
    "code": "NGA",
  },
  {
    "name": "Niue",
    "phoneCode": "+683",
    "alpha2code": "NU",
    "code": "NIU",
  },
  {
    "name": "Norfolk Island",
    "phoneCode": "+672",
    "alpha2code": "NF",
    "code": "NFK",
  },
  {
    "name": "Democratic People's Republic of Korea",
    "phoneCode": "+850",
    "alpha2code": "KP",
    "code": "PRK",
  },
  {
    "name": "Norway",
    "phoneCode": "+47",
    "alpha2code": "NO",
    "code": "NOR",
  },
  {
    "name": "Oman",
    "phoneCode": "+968",
    "alpha2code": "OM",
    "code": "OMN",
  },
  {
    "name": "Pakistan",
    "phoneCode": "+92",
    "alpha2code": "PK",
    "code": "PAK",
  },
  {
    "name": "Palau",
    "phoneCode": "+680",
    "alpha2code": "PW",
    "code": "PLW",
  },
  {
    "name": "Palestine",
    "phoneCode": "+970",
    "alpha2code": "PS",
    "code": "PSE",
  },
  {
    "name": "Panama",
    "phoneCode": "+507",
    "alpha2code": "PA",
    "code": "PAN",
  },
  {
    "name": "Papua New Guinea",
    "phoneCode": "+675",
    "alpha2code": "PG",
    "code": "PNG",
  },
  {
    "name": "Paraguay",
    "phoneCode": "+595",
    "alpha2code": "PY",
    "code": "PRY",
  },
  {
    "name": "Peru",
    "phoneCode": "+51",
    "alpha2code": "PE",
    "code": "PER",
  },
  {
    "name": "Philippines",
    "phoneCode": "+63",
    "alpha2code": "PH",
    "code": "PHL",
  },
  {
    "name": "Poland",
    "phoneCode": "+48",
    "alpha2code": "PL",
    "code": "POL",
  },
  {
    "name": "Portugal",
    "phoneCode": "+351",
    "alpha2code": "PT",
    "code": "PRT",
  },
  {
    "name": "Qatar",
    "phoneCode": "+974",
    "alpha2code": "QA",
    "code": "QAT",
  },
  {
    "name": "Congo",
    "phoneCode": "+242",
    "alpha2code": "CG",
    "code": "COG",
  },
  {
    "name": "Réunion",
    "phoneCode": "+262",
    "alpha2code": "RE",
    "code": "REU",
  },
  {
    "name": "Romania",
    "phoneCode": "+40",
    "alpha2code": "RO",
    "code": "ROU",
  },
  {
    "name": "Russia",
    "phoneCode": "+7",
    "alpha2code": "RU",
    "code": "RUS",
  },
  {
    "name": "Rwanda",
    "phoneCode": "+250",
    "alpha2code": "RW",
    "code": "RWA",
  },
  {
    "name": "Saint Barthélemy",
    "phoneCode": "+590",
    "alpha2code": "BL",
    "code": "BLM",
  },
  {
    "name": "Saint Helena",
    "phoneCode": "+290",
    "alpha2code": "SH",
    "code": "SHN",
  },
  {
    "name": "Saint Kitts and Nevis",
    "phoneCode": "+1",
    "alpha2code": "KN",
    "code": "KNA",
  },
  {
    "name": "Saint Martin",
    "phoneCode": "+590",
    "alpha2code": "MF",
    "code": "MAF",
  },
  {
    "name": "Saint Pierre and Miquelon",
    "phoneCode": "+508",
    "alpha2code": "PM",
    "code": "SPM",
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "phoneCode": "+1",
    "alpha2code": "VC",
    "code": "VCT",
  },
  {
    "name": "Samoa",
    "phoneCode": "+685",
    "alpha2code": "WS",
    "code": "WSM",
  },
  {
    "name": "San Marino",
    "phoneCode": "+378",
    "alpha2code": "SM",
    "code": "SMR",
  },
  {
    "name": "São Tomé and Príncipe",
    "phoneCode": "+239",
    "alpha2code": "ST",
    "code": "STP",
  },
  {
    "name": "Saudi Arabia",
    "phoneCode": "+966",
    "alpha2code": "SA",
    "code": "SAU",
  },
  {
    "name": "Senegal",
    "phoneCode": "+221",
    "alpha2code": "SN",
    "code": "SEN",
  },
  {
    "name": "Serbia",
    "phoneCode": "+381",
    "alpha2code": "RS",
    "code": "SRB",
  },
  {
    "name": "Seychelles",
    "phoneCode": "+248",
    "alpha2code": "SC",
    "code": "SYC",
  },
  {
    "name": "Sierra Leone",
    "phoneCode": "+232",
    "alpha2code": "SL",
    "code": "SLE",
  },
  {
    "name": "Singapore",
    "phoneCode": "+65",
    "alpha2code": "SG",
    "code": "SGP",
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "phoneCode": "+1",
    "alpha2code": "SX",
    "code": "SXM",
  },
  {
    "name": "Slovakia",
    "phoneCode": "+421",
    "alpha2code": "SK",
    "code": "SVK",
  },
  {
    "name": "Slovenia",
    "phoneCode": "+386",
    "alpha2code": "SI",
    "code": "SVN",
  },
  {
    "name": "Solomon Islands",
    "phoneCode": "+677",
    "alpha2code": "SB",
    "code": "SLB",
  },
  {
    "name": "Somalia",
    "phoneCode": "+252",
    "alpha2code": "SO",
    "code": "SOM",
  },
  {
    "name": "South Africa",
    "phoneCode": "+27",
    "alpha2code": "ZA",
    "code": "ZAF",
  },
  {
    "name": "Republic of Korea",
    "phoneCode": "+82",
    "alpha2code": "KR",
    "code": "KOR",
  },
  {
    "name": "South Sudan",
    "phoneCode": "+211",
    "alpha2code": "SS",
    "code": "SSD",
  },
  {
    "name": "Spain",
    "phoneCode": "+34",
    "alpha2code": "ES",
    "code": "ESP",
  },
  {
    "name": "Sri Lanka",
    "phoneCode": "+94",
    "alpha2code": "LK",
    "code": "LKA",
  },
  {
    "name": "Saint Lucia",
    "phoneCode": "+1",
    "alpha2code": "LC",
    "code": "LCA",
  },
  {
    "name": "Sudan",
    "phoneCode": "+249",
    "alpha2code": "SD",
    "code": "SDN",
  },
  {
    "name": "Suriname",
    "phoneCode": "+597",
    "alpha2code": "SR",
    "code": "SUR",
  },
  {
    "name": "Swaziland",
    "phoneCode": "+268",
    "alpha2code": "SZ",
    "code": "SWZ",
  },
  {
    "name": "Sweden",
    "phoneCode": "+46",
    "alpha2code": "SE",
    "code": "SWE",
  },
  {
    "name": "Switzerland",
    "phoneCode": "+41",
    "alpha2code": "CH",
    "code": "CHE",
  },
  {
    "name": "Syrian Arab Republic",
    "phoneCode": "+963",
    "alpha2code": "SY",
    "code": "SYR",
  },
  {
    "name": "Taiwan",
    "phoneCode": "+886",
    "alpha2code": "TW",
    "code": "TWN",
  },
  {
    "name": "Tajikistan",
    "phoneCode": "+992",
    "alpha2code": "TJ",
    "code": "TJK",
  },
  {
    "name": "Tanzania",
    "phoneCode": "+255",
    "alpha2code": "TZ",
    "code": "TZA",
  },
  {
    "name": "Thailand",
    "phoneCode": "+66",
    "alpha2code": "TH",
    "code": "THA",
  },
  {
    "name": "Bahamas",
    "phoneCode": "+1",
    "alpha2code": "BS",
    "code": "BHS",
  },
  {
    "name": "Gambia",
    "phoneCode": "+220",
    "alpha2code": "GM",
    "code": "GMB",
  },
  {
    "name": "Timor-Leste",
    "phoneCode": "+670",
    "alpha2code": "TL",
    "code": "TLS",
  },
  {
    "name": "Togo",
    "phoneCode": "+228",
    "alpha2code": "TG",
    "code": "TGO",
  },
  {
    "name": "Tokelau",
    "phoneCode": "+690",
    "alpha2code": "TK",
    "code": "TKL",
  },
  {
    "name": "Tonga",
    "phoneCode": "+676",
    "alpha2code": "TO",
    "code": "TON",
  },
  {
    "name": "Trinidad and Tobago",
    "phoneCode": "+1",
    "alpha2code": "TT",
    "code": "TTO",
  },
  {
    "name": "Tunisia",
    "phoneCode": "+216",
    "alpha2code": "TN",
    "code": "TUN",
  },
  {
    "name": "Turkey",
    "phoneCode": "+90",
    "alpha2code": "TR",
    "code": "TUR",
  },
  {
    "name": "Turkmenistan",
    "phoneCode": "+993",
    "alpha2code": "TM",
    "code": "TKM",
  },
  {
    "name": "Turks and Caicos Islands",
    "phoneCode": "+1",
    "alpha2code": "TC",
    "code": "TCA",
  },
  {
    "name": "Tuvalu",
    "phoneCode": "+688",
    "alpha2code": "TV",
    "code": "TUV",
  },
  {
    "name": "Uganda",
    "phoneCode": "+256",
    "alpha2code": "UG",
    "code": "UGA",
  },
  {
    "name": "Ukraine",
    "phoneCode": "+380",
    "alpha2code": "UA",
    "code": "UKR",
  },
  {
    "name": "United Arab Emirates",
    "phoneCode": "+971",
    "alpha2code": "AE",
    "code": "ARE",
  },
  {
    "name": "United Kingdom",
    "phoneCode": "+44",
    "alpha2code": "GB",
    "code": "GBR",
  },
  {
    "name": "Uruguay",
    "phoneCode": "+598",
    "alpha2code": "UY",
    "code": "URY",
  },
  {
    "name": "Uzbekistan",
    "phoneCode": "+998",
    "alpha2code": "UZ",
    "code": "UZB",
  },
  {
    "name": "Vanuatu",
    "phoneCode": "+678",
    "alpha2code": "VU",
    "code": "VUT",
  },
  {
    "name": "Vatican City",
    "phoneCode": "+39",
    "alpha2code": "VA",
    "code": "VAT",
  },
  {
    "name": "Venezuela",
    "phoneCode": "+58",
    "alpha2code": "VE",
    "code": "VEN",
  },
  {
    "name": "Vietnam",
    "phoneCode": "+84",
    "alpha2code": "VN",
    "code": "VNM",
  },
  {
    "name": "Wallis and Futuna",
    "phoneCode": "+681",
    "alpha2code": "WF",
    "code": "WLF",
  },
  {
    "name": "Yemen",
    "phoneCode": "+967",
    "alpha2code": "YE",
    "code": "YEM",
  },
  {
    "name": "Zambia",
    "phoneCode": "+260",
    "alpha2code": "ZM",
    "code": "ZMB",
  },
  {
    "name": "Zimbabwe",
    "phoneCode": "+263",
    "alpha2code": "ZW",
    "code": "ZWE",
  },
];


export const states = {
  "PA": "Pennsylvania",
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming",
};
